<template>
  <div class="online-cv-wrapper" :style="{iosOrAndroidStyle, 'backgroundColor': '#f9f9f9'}">
    <w-nav-bar nav_title="隐私设置" @mobileLeftBtn="routerBack" v-show="iosOrAndroidShow"/>
    <div v-show="!loadingShow">
      <div class="recommend_title">
        <span class="recommend_title_text">推荐选项</span>
<!--        <span class="sub_title_text">开启后将向指定对象推荐您的在线简历</span>-->
      </div>
      <div class="privacy-set flex-between backColor one_line">
        <p class="headline title">对企业 HR 推荐</p>
        <div class="recommend-hr" @click.prevent="handleRecommendHr('recommend_for_hr')">
          <cube-switch v-model="privacy.recommend_for_hr" />
        </div>
      <div class="triangle" v-if="privacy.recommend_for_hr">
        <div class="triangle-one"/>
        <div class="triangle-two"/>
        <div class="triangle-three"/>
      </div>
      </div>
       <template v-if="privacy.recommend_for_hr">
        <!-- <div class="recommend_title">
          <span class="recommend_title_text">曝光选项</span>
        </div> -->
        <div class="privacy-set flex-between backColor">
          <div class="recommend-inner_padding">
            <p class="headline title">直接联系</p>
            <p class="description">认证的 HR /推荐人可在发起邀请后获得你的电话</p>
          </div>
          <div @click.prevent="handleRecommendHr('contact_directly')">
            <cube-switch v-model="privacy.contact_directly"/>
          </div>
        </div>
        <div class="privacy-set flex-between backColor">
          <div class="recommend-inner_padding">
            <p class="headline title">加强曝光</p>
            <p class="description">优先推荐你的简历，限时免费</p>
          </div>
          <div @click.prevent="changePrivacy('increase_exposure')">
            <cube-switch v-model="privacy.increase_exposure"/>
          </div>
        </div>
<!--        <div class="privacy-set flex-between backColor">-->
<!--          <div>-->
<!--            <p class="headline title">站内联系</p>-->
<!--            <p class="description">只允许HR通过站内信联系我，不能电话联系我</p>-->
<!--          </div>-->
<!--          <cube-switch v-model="privacy.contact_insite" @input="changePrivacy" />-->
<!--        </div>-->
      </template>
      <div class="privacy-set flex-between backColor one_line">
        <div>
          <p class="headline title">对校友/前同事关系推荐</p>
        </div>
        <div @click.prevent="changePrivacy('recommend_for_classmate')">
          <cube-switch v-model="privacy.recommend_for_classmate" />
        </div>
      </div>
      <div class="privacy-set flex-between backColor one_line">
        <div>
          <p class="headline title">对有内推资源者推荐</p>
        </div>
        <div @click.prevent="changePrivacy('recommend_for_internal')">
          <cube-switch v-model="privacy.recommend_for_internal" />
        </div>
      </div>
      <div class="privacy-set flex-between backColor mar-t-10" v-show="!isIos" @click="setCompanyPrivacy">
        <div>
          <p class="headline title">屏蔽公司</p>
          <p class="description">屏蔽后 HR 将无法看到你的简历</p>
        </div>
        <span class="iconfont iconchevron-right"></span>
      </div>
      <div class="service_agreement"><a class="link" href="/cvs/service-agreement">《超级简历用户服务协议》</a>和<a class="link" href="/cvs/privacy-clause">《隐私条款》</a></div>
    </div>
    <w-loading v-show="loadingShow"></w-loading>
  </div>
</template>

<script>
	import WNavBar from '@/components/global/w-navbar'
  import WLoading from '../../components/global/w-loading'
	import { mapActions, mapState, mapMutations } from 'vuex'
	import Cookies from 'js-cookie'
	import { componentsMixin } from '../../assets/js/mixin/components'
	import { envMixin } from '../../assets/js/mixin/global'
  import { userMixin } from '../../assets/js/mixin/user'
  // import api from '../../api/api-list'

	export default {
		name: 'privacy-set',
		mixins: [ envMixin, componentsMixin, userMixin ],
		data () {
			return {
				switchValue: null,
        showVisibility: false,
        loadingShow: true,
        privacy: {
          recommend_for_hr: false,   // 对企业HR推荐
          recommend_for_classmate: false, // 对校友/前同事推荐
          recommend_for_internal: false,   // 对有内推资源者推荐
          increase_exposure: false, // 加强曝光
          contact_directly: false,   // 	直接联系
          contact_insite: false   // 站内联系
        },
        recommendCvData: {}
			}
		},
		async mounted () {
      this.getCvListData()
			this.getOnlineCvData()
			await this.getVisibility(this.cvAccountToken)
			this._initValue()
      this.getPersonPrivacy()
		},
		computed: {
			...mapState('cv', [ 'onlineVisibility', 'onlineCvValid', ]),
      ...mapState('cvIndex', ['cvList']),
			cvAccountToken () {
				let _t = Cookies.get('_t')
				let tokenPayload = JSON.parse(window.atob(_t.split('.')[1]))
				return tokenPayload.User.c_t
			},
		},
		watch: {
			switchValue (newVal, oldVal) {
				if (typeof oldVal === 'boolean') this.change(newVal)
      }
    },
		components: {
			WNavBar,
      WLoading
		},
		methods: {
			...mapActions('cv', [ 'getVisibility', 'checkCvValid' ]),
      ...mapActions('cvIndex', ['getCvList']),
      ...mapMutations('user', [ 'setIsNeedResume' ]),
      handleRecommendHr(value) {
			  if (this.privacy[value]) {
			    this.recommendForHrDialog(value)
        } else {
          this.syncRecommendCv(value)
        }
      },
      // 关闭对企业/hr推荐时的阻断弹窗
      recommendForHrDialog(value) {
			  const content = value === 'recommend_for_hr' ? '关闭推荐可能会错过心动的offer，你可以通过屏蔽公司对部分公司隐藏简历' : '关闭后HR将无法联系你，可能会错过心动的offer，你可以通过屏蔽公司对部分公司隐藏简历'
        this.$createDialog({
          title: '提示',
          type: 'confirm',
          content,
          confirmBtn: {
            text: '去屏蔽',
          },
          cancelBtn: {
            text: value === 'recommend_for_hr' ? '关闭推荐' : '确认关闭',
          },
          onConfirm: this.setCompanyPrivacy,
          onCancel: () => { this.changePrivacy(value) }
        }).show()
      },
      // 同步在线简历
      syncRecommendCv(value) {
        if (value === 'recommend_for_hr') {
          const list = this.cvList.filter(item => item.can_editable && !item.is_mentor && item.lang === 'cn')
          if (list.length === 1) {
            const { token, score } = list[0]
            this.getUserData().then(_data => {
              if (this.userData && !this.userData.intention) {
                this.setIsNeedResume(true)
                this.$router.push('/job/intentions')
              } else {
                this.checkCvValid(token).then(_ => {
                  if (Object.values(this.onlineCvValid).every(item => item)) {
                    if (score >= 60) {
                      this.$api.online.createOnlineCv({ token }).then(res => {
                        if (res.code === 1000) {
                          this.showToast('简历已推荐')
                          this.changePrivacy(value)
                        } else {
                          this.showToast(res.message)
                        }
                      })
                    } else {
                      this.$createDialog({
                        type: 'confirm',
                        title: '简历完善提示',
                        content: `设置在线简历需要简历评分高于60分，请继续加油～`,
                        confirmBtn: { text: '去完善' },
                        onConfirm: () => {
                          this.$router.push({
                            path: `/cvs/${ token }/editor`
                          })
                        }
                      }).show()
                    }
                  } else {
                    let errorMessage = ''
                    for (const [key, value] of Object.entries(this.onlineCvValid)) {
                      if (!value) {
                        if (key === 'name_valid' || key === 'gender_valid' || key === 'contact_valid') {
                          errorMessage += `基本信息、`
                        } else if (key === 'work_valid') {
                          errorMessage += `工作经历、`
                        } else if (key === 'edu_valid') {
                          errorMessage += `教育经历、`
                        }
                      }
                    }
                    this.$createDialog({
                      type: 'confirm',
                      title: '简历完善提示',
                      content: `当前 <span class="error-light">${errorMessage.slice(0, -1)}</span> 不完整`,
                      confirmBtn: { text: '去完善' },
                      onConfirm: () => {
                        this.$router.push({
                          path: `/cvs/online/${ token }/base`
                        })
                      }
                    }).show()
                  }
                })
              }
            })
          } else if (this.showVisibility) {
            const moment = require('moment')
            let updatedAt = this.recommendCvData.updated_at || this.recommendCvData.resume.resume.updated_at
            const data = updatedAt ? list.find(item => moment(item.update_time).diff(updatedAt, 'seconds') > 0) : ''
            if (data) {
              this.$router.push('/cvs/online/list')
            } else {
			        this.changePrivacy(value)
            }
          }
        } else {
			    this.changePrivacy(value)
        }
      },
      // 设置隐私设置
      async changePrivacy(value) {
			  try {
          let res = await this.$api.user.setPersonPrivacy(this.cvAccountToken, { ...this.privacy, [value]: !this.privacy[value] })
          if (res.code === 1000) {
            this.privacy = res.data
            // let toast = value ? '已打开' : '已关闭'
            // this.showToast(toast)
          } else {
            this.showToast(res.message)
          }
        } catch (e) {
			    console.error(e)
        }
      },
      // 获取个人隐私设置
      async getPersonPrivacy() {
			  try {
          let res = await this.$api.user.getPersonPrivacy(this.cvAccountToken)
          if (res.code === 1000) {
            this.privacy = res.data
          } else{
            this.showToast(res.message, 1500)
          }
        } catch (e) {
			    console.error(e)
        }
      },
			_initValue () {
				this.switchValue = this.onlineVisibility
			},
			routerBack () {
        let { pageSource } = this.$route.query
        if (pageSource === 'preview' && !this.privacy.recommend_for_hr) {
          this.$router.replace('/cvs')
        } else {
				  this.$router.back()
        }
			},
      // 去屏蔽公司列表页
      setCompanyPrivacy () {
				this.$router.push('/account/privacy/company-list')
      },
      // 切换私密度
			async change (val) {
				let res = await this.$api.online.updateVisibility({ cv_invisibile: val }, this.cvAccountToken)
				if (res.code === 1000) {
					let toast = val ? '已隐藏' : '已取消隐藏'
					this.showToast(toast)
				}
			},
      // 获取在线简历
      async getOnlineCvData () {
	      let res = await this.$api.online.getOnlineCv(this.cvAccountToken);
	      if (res.code === 1000 || res.code === 80139) {
		      this.showVisibility = true
          this.recommendCvData = res.data
	      }
	      this.loadingShow = false
      },
      getCvListData() {
        if (!this.cvList.length) {
          this.getCvList({
            page: 1,
            size: 20
          })
        }
      }
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/mixin';
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/cv/online-cv';
  .recommend_title{
    width: 100%;
    height: 46px;
    padding-left: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .recommend_title_text {
      color: #404040;
      font-size: 16px;
    }
    .sub_title_text {
      font-size: 12px;
      color: #9c9c9c;
      margin-top: 8px;
    }
  }
  .service_agreement {
    width: 266px;
    margin-left: 55px;
    color: #9c9c9c;
    // margin-top: 41px;
    margin-bottom: 70px;
    position: absolute;
    bottom: 0;
    .link {
      color: #9c9c9c;
    }
  }
  .one_line {
    height: 54px;
  }
  //.exposure {
  //  height: 40px;
  //}
  .backColor {
    background-color: #fff;
  }
  .mar-t-10 {
    margin-top: 10px;
  }
  .privacy-set {
    padding: 16px 24px 16px;
    position: relative;
    //&:last-child:after {
    //  display: none;
    //}
    //&:after {
    //  content: '';
    //  display: block;
    //  width: 343px;
    //  border-top: 1px solid #f4f4f4;
    //  position: absolute;
    //  bottom: 0;
    //  left: 16px;
    //}
    border-bottom: 1px solid #f4f4f4;
    .title {
      //margin-bottom: 8px;
    }
    .description {
      font-size: $font-size-small;
      color: #9C9C9C;
      margin-top: 8px;
    }
    .iconchevron-right {
      color: #CFCFCF;
      font-size: 18px;
      font-weight: 500;
    }
    /deep/.cube-switch {
      .cube-switch-input:checked + {
        .cube-switch-ui {
          border-color: #ff6644;
          background-color: #ff6644;
          //height: 22px;
        }
      }
      .cube-switch-ui {
        border-color: rgba(0, 0, 0,.25);
        //height: 22px;
        &::before {
          background-color: rgba(0, 0, 0,.25);
          border-color: rgba(0, 0, 0,.25);
        }
        &::after {
          //width: 22px;
          /*transform: translateX(26px);*/
        }
      }
    }
    .recommend-inner_padding {
      padding-left: 12px;
    }
    .triangle {
      position: absolute;
      bottom: -1px;
      background-color: #feffff;
      // background-color: #000;
      width: 15px;
      height: 10px;
      left: 66px;
      padding-top: 5px;
      z-index: 1;
      .triangle-one {
        background-color: #f4f4f4;
        width: 10px;
        height: 1px;
        transform: rotate(135deg);
      }
      .triangle-two {
        background-color: #f4f4f4;
        width: 13px;
        height: 1px;
        margin-left: 7px;
        transform: rotate(45deg);
      }
      .triangle-three {
        background-color: #f4f4f4;
        width: 2px;
        height: 1px;
        bottom: 0px;
        position: absolute;
      }
    }
    // <View style={{position: 'absolute', bottom: 0, left: 65, backgroundColor: '#feffff', height: 10, width: 15, zIndex: 1}}>
    //   <View style={{backgroundColor: '#f4f4f4', width: 13, height: 1, top: 6,transform: [{rotate: "135deg"}]}}/>
    //   <View style={{backgroundColor: '#f4f4f4', width: 13, height: 1, left: 7,top: 5,transform: [{rotate: "45deg"}]}}/>
    //   <View style={{backgroundColor: '#f4f4f4', width: 2, height: 1,bottom: 0, position: 'absolute'}}/>
    // </View>
  }
</style>
